const InitialStateITRJourney = {
  previousScreen: 'NO_SCREEN_TO_SHOW',
  currentScreen: 'WELCOME_BS_SCREEN',
  globalOverlayLoader: false,
  // DOCS: show welcome screen, only be shown if user clicks I will do it later and comes back through clicking on fibe card
  showITRWelcomeScreen: true,
  screenConstHistory: [],
  // DOCS: Flow type can be ONLINE or OFFLINE, used for moving back logic on Ack screen
  flowTypeEnum: '',
  // DOCS: journey type can be SUSPEND, NORMAL, LIMIT_ENHANCE used in API Payload for journey type
  journeyTypeEnum: 'NORMAL',
  rightSidebarOpenFlag: false,
  uploadITRFileBtnClicked: false,
  itrPassword: '',
  ackScreen: {
    statusCode: '',
    statusMsg: '',
    statusDes: '',
    bgImg: '',
    fiboLottieJSON: '',
  },
  monthlyStatementErr: {
    isError: false,
    errorMsg: '',
  },
  globalOverlayLoader: false,
  perfiosOnlineBankingAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bsVerifyTxnAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  s3FileUploadAPICall: {
    uploadFileResponses: [null, null, null, null],
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  saveBsDocUploadAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  skipItrSaveAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export default InitialStateITRJourney;
